import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useChangeCoverageOrcaCa } from './useChangeCoverageOrcaCa';
import {
  getCoveragePeriodRequest,
  getMultibrandDefaultPolicy,
  getOrcaCustomerValues,
} from '../../../../actions';

export const useChangeCoverageOrcaEffect = () => {
  const dispatch = useDispatch();

  const {
    baseProducts,
    coveragePeriodId,
    defaultPolicy,
    paymentManagementUrl,
    petId,
    policyNumber,
    productName,
    queryPetId,
    selectedPet,
  } = useChangeCoverageOrcaCa();

  useEffect(() => {
    if (queryPetId) {
      dispatch(getMultibrandDefaultPolicy(queryPetId));
    }
  }, [queryPetId]);

  useEffect(() => {
    if (!paymentManagementUrl) {
      return;
    }

    const productLoaded = baseProducts.some(({ display }) => display);

    if (!productLoaded && defaultPolicy?.Id) {
      const effectiveOn = defaultPolicy.PolicyEndDate.split('T')[0];

      dispatch(getCoveragePeriodRequest({
        coveragePeriodId,
        currentPetId: selectedPet.petId,
        effectiveOn,
        managementUrl: paymentManagementUrl,
        productName,
      }));
    }
  }, [
    coveragePeriodId,
    defaultPolicy,
    paymentManagementUrl,
    petId,
    baseProducts,
    selectedPet,
  ]);

  useEffect(() => {
    if (policyNumber && !paymentManagementUrl) {
      dispatch(getOrcaCustomerValues({ PolicyId: policyNumber }));
    }
  }, [paymentManagementUrl, policyNumber]);
};
